var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActiveTick(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49993 8.49961L1.58327 5.58294C1.25827 5.25794 0.741602 5.25794 0.416602 5.58294C0.0916016 5.90794 0.0916016 6.42461 0.416602 6.74961L3.90827 10.2413C4.23327 10.5663 4.75827 10.5663 5.08327 10.2413L13.9166 1.41628C14.2416 1.09128 14.2416 0.574609 13.9166 0.249609C13.5916 -0.0753906 13.0749 -0.0753906 12.7499 0.249609L4.49993 8.49961Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTick);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNDk5OTMgOC40OTk2MUwxLjU4MzI3IDUuNTgyOTRDMS4yNTgyNyA1LjI1Nzk0IDAuNzQxNjAyIDUuMjU3OTQgMC40MTY2MDIgNS41ODI5NEMwLjA5MTYwMTYgNS45MDc5NCAwLjA5MTYwMTYgNi40MjQ2MSAwLjQxNjYwMiA2Ljc0OTYxTDMuOTA4MjcgMTAuMjQxM0M0LjIzMzI3IDEwLjU2NjMgNC43NTgyNyAxMC41NjYzIDUuMDgzMjcgMTAuMjQxM0wxMy45MTY2IDEuNDE2MjhDMTQuMjQxNiAxLjA5MTI4IDE0LjI0MTYgMC41NzQ2MDkgMTMuOTE2NiAwLjI0OTYwOUMxMy41OTE2IC0wLjA3NTM5MDYgMTMuMDc0OSAtMC4wNzUzOTA2IDEyLjc0OTkgMC4yNDk2MDlMNC40OTk5MyA4LjQ5OTYxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };